(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('CheckSaveEditController', CheckSaveEditController);

    CheckSaveEditController.$inject = ['$state', '$scope', '$uibModalInstance', 'query'];

    function CheckSaveEditController($state, $scope, $uibModalInstance, query) {
        var vm = this;

        vm.lastQuery = query.lastQuery;
        vm.newQuery = query.newQuery;

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            $uibModalInstance.close();
        };

    }
})();
